export type CylinderSizingLimitLookup = {
  standardLowerLimit: number | null;
  standardUpperLimit: number | null;
  solarLowerLimit: number | null;
  solarUpperLimit: number | null;
};

export const cylinderSizingLookupsByHeatPumpUnitName: Record<string, CylinderSizingLimitLookup> = {
  'HPG1156S/8-A': { standardLowerLimit: null, standardUpperLimit: 500, solarLowerLimit: null, solarUpperLimit: 800 },
  'HPG1156S/13-A': { standardLowerLimit: null, standardUpperLimit: 800, solarLowerLimit: null, solarUpperLimit: null },
  'HPG1156S/18-A': { standardLowerLimit: 400, standardUpperLimit: null, solarLowerLimit: 400, solarUpperLimit: null },
  'HPG1345N/24(24)-A': {
    standardLowerLimit: null,
    standardUpperLimit: 800,
    solarLowerLimit: null,
    solarUpperLimit: null,
  },
  'HPG1345N/30(30)-A': {
    standardLowerLimit: 300,
    standardUpperLimit: null,
    solarLowerLimit: 300,
    solarUpperLimit: null,
  },
  'HPG1345N/40(40)-A': {
    standardLowerLimit: 400,
    standardUpperLimit: null,
    solarLowerLimit: 400,
    solarUpperLimit: null,
  },
  // HPF2040-12 series should have the same limits regardless of suffix
  'HPF2040/12(10)-A': {
    standardLowerLimit: null,
    standardUpperLimit: 600,
    solarLowerLimit: null,
    solarUpperLimit: 800,
  },
  'HPF2040/12(10)B-A': {
    standardLowerLimit: null,
    standardUpperLimit: 600,
    solarLowerLimit: null,
    solarUpperLimit: 800,
  },
  // HPF2040-16 series should have the same limits regardless of suffix
  'HPF2040/16(13)-A': {
    standardLowerLimit: 300,
    standardUpperLimit: 800,
    solarLowerLimit: 300,
    solarUpperLimit: null,
  },
  'HPF2040/16(13)B-A': {
    standardLowerLimit: 300,
    standardUpperLimit: 800,
    solarLowerLimit: 300,
    solarUpperLimit: null,
  },
};
